enum EExportarExtratoTipoMensagem {
  SUCESSO = 'sucesso',
  ERRO = 'erro',
  VALIDACAO_PERIODO = 'validacao_periodo',
}

export const ExportarExtratoTipoMensagem: {
  [key in EExportarExtratoTipoMensagem]: number
} = {
  [EExportarExtratoTipoMensagem.SUCESSO]: 1,
  [EExportarExtratoTipoMensagem.ERRO]: 2,
  [EExportarExtratoTipoMensagem.VALIDACAO_PERIODO]: 3,
}

export default EExportarExtratoTipoMensagem
